import { z } from 'zod/v4';

export const AdminGetWebshopParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminGetWebshopParams = z.infer<typeof AdminGetWebshopParamsSchema>;
